import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { a11y } from '~js/components/a11y';
import { DelayShow } from '~js/components/delay-show';
import { TargetReferrer } from '~js/components/target-referrer';
import { PopupCookie } from '~js/components/popup-cookie';

export class PopupBar {
  constructor(el) {
    this.popupContainer = el;
    this.popup = this.popupContainer.querySelector(s.selectors$d.popupBarHolder);
    this.popupBody = this.popup.querySelector(s.selectors$d.popupBody);
    this.popupId = this.popup.id;
    this.close = this.popup.querySelector(s.selectors$d.popupClose);
    this.underlay = this.popup.querySelector(s.selectors$d.popupUnderlay);
    this.toggle = this.popup.querySelector(s.selectors$d.popupBarToggle);
    this.cookie = new PopupCookie(this.popupContainer.dataset.cookieName, 'user_has_closed');
    this.form = this.popup.querySelector(s.selectors$d.newsletterForm);
    this.isTargeted = new TargetReferrer(this.popupContainer);
    this.a11y = a11y;

    this.init();
  }

  init() {
    const cookieExists = this.cookie.read() !== false;

    if (!cookieExists || window.Shopify.designMode) {
      if (!window.Shopify.designMode) {
        new DelayShow(this.popupContainer, this.popup);
      } else {
        this.showPopup();
      }

      this.initPopupToggleButton();
      this.initClosers();

      if (this.form) {
        setTimeout(() => {
          if (this.form.classList.contains(c.classes$b.success)) {
            this.showPopupIfNoCookie();
          }

          if (this.form.classList.contains(c.classes$b.error)) {
            // Expand popup if form has error
            this.toggle.dispatchEvent(new Event('click'));
          }
        });
      }
    }
  }

  checkPopupTarget() {
    const targetMobile = this.popup.parentNode.classList.contains(c.classes$b.mobile);
    const targetDesktop = this.popup.parentNode.classList.contains(c.classes$b.desktop);

    if (
      (targetMobile && window.innerWidth >= theme.sizes.small) ||
      (targetDesktop && window.innerWidth < theme.sizes.small)
    ) {
      return false;
    } else {
      return true;
    }
  }

  showPopupIfNoCookie() {
    this.showPopup();
    this.toggle.dispatchEvent(new Event('click'));
  }

  initPopupToggleButton() {
    this.toggle.addEventListener('click', (event) => {
      event.preventDefault();

      this.popup.classList.toggle(c.classes$b.expanded);

      if (this.popup.classList.contains(c.classes$b.expanded)) {
        this.scrollLock();
      } else {
        this.scrollUnlock();
      }
    });
  }

  showPopup() {
    const popupElement = { id: this.popupId, body: this.popup };
    popups.push(popupElement);
    this.a11y.trapFocus({
      container: this.popupBody,
    });
    const isTargetValid = this.checkPopupTarget() === true;
    if (isTargetValid) {
      activePopups += 1;
      document.body.classList.add(c.classes$b.barIsVisible);
      this.popup.classList.add(c.classes$b.visible);
    }
  }

  hidePopup() {
    this.popup.classList.remove(c.classes$b.visible);
    document.body.classList.remove(c.classes$b.barIsVisible);
    const popupIndex = popups.findIndex((x) => x.id === this.popupId);
    popups.splice(popupIndex, 1);

    if (activePopups >= 1) {
      activePopups -= 1;
    }

    if (activePopups < 1) {
      this.scrollUnlock();
      this.a11y.removeTrapFocus();
    } else if (popups.length > 0) {
      const nextPopup = popups[popups.length - 1].body;
      this.a11y.trapFocus({
        container: nextPopup,
      });
    }
  }

  initClosers() {
    this.close.addEventListener('click', this.closePopup.bind(this));
    this.underlay.addEventListener('click', () => this.toggle.dispatchEvent(new Event('click')));
    this.popupContainer.addEventListener('keyup', (event) => {
      if (event.code === theme.keyboardKeys.ESCAPE) {
        this.popup.classList.remove(c.classes$b.expanded);
        this.scrollUnlock();
      }
    });
  }

  closePopup(event) {
    event.preventDefault();

    this.cookie.write();
    this.hidePopup();
  }

  scrollLock() {
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.popupBody }));
  }

  scrollUnlock() {
    this.resetScrollUnlock();

    // Unlock scrollbar after popup animation completes
    scrollLockTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }, 300);
  }

  resetScrollUnlock() {
    if (scrollLockTimer) {
      clearTimeout(scrollLockTimer);
    }
  }

  onBlockSelect(evt) {
    if (this.popupContainer.contains(evt.target) && !this.popup.classList.contains(c.classes$b.visible)) {
      this.showPopup();
      this.popup.classList.add(c.classes$b.expanded);
      this.popup.classList.add(c.classes$b.selected);
      this.popup.parentNode.classList.add(c.classes$b.hasBlockSelected);
      this.resetScrollUnlock();
      this.scrollLock();
    }
  }

  onBlockDeselect(evt) {
    if (this.popupContainer.contains(evt.target)) {
      this.popup.classList.remove(c.classes$b.expanded);
      this.popup.classList.remove(c.classes$b.selected);
      this.popup.parentNode.classList.remove(c.classes$b.hasBlockSelected);
      this.hidePopup();
    }
  }

  onUnload() {
    this.scrollUnlock();
  }

  onDeselect() {
    this.popup.classList.remove(c.classes$b.expanded);
    this.popup.classList.remove(c.classes$b.selected);
    this.popup.parentNode.classList.remove(c.classes$b.hasBlockSelected);
    this.hidePopup();
  }
}